import { Box, Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { JobDetailsData } from '../../../types';
import type { JobDetailsTabProps } from './JobDetailsTab.types';

const WORKPLACE_LABEL: Record<
  NonNullable<JobDetailsData['workplace']>,
  string
> = {
  onsite: 'Onsite',
  hybrid: 'Hybrid',
  remote: 'Remote',
};

const formatSalary = (salary: JobDetailsData['salary']): string | null => {
  if (!salary) return null;
  const fmt = (n: number) =>
    `$${Math.round(n / 1000).toLocaleString('en-US')}k`;
  return `${fmt(salary.min)} - ${fmt(salary.max)}`;
};

const buildSubtitleParts = (data: JobDetailsData): string[] => {
  const salary = formatSalary(data.salary);
  return [
    salary,
    data.location,
    data.employmentType,
    data.workplace ? WORKPLACE_LABEL[data.workplace] : null,
  ].filter((part): part is string => part !== null && part !== undefined);
};

export const JobDetailsTab = ({ data }: JobDetailsTabProps) => {
  const subtitleParts = buildSubtitleParts(data);

  return (
    <Flex direction="column" gap="14px">
      <Box>
        <Text variant="small" className="text-secondary-400 block mb-1">
          Req ID — {data.reqId}
        </Text>
        <Text variant="h3" className="text-secondary-900 block mb-2">
          {data.title}
        </Text>
        {subtitleParts.length > 0 && (
          <Text variant="small" className="text-secondary-700">
            {subtitleParts.join(' · ')}
          </Text>
        )}
      </Box>
      <Box
        bg="secondary-50"
        borderRadius="8px"
        px="12px"
        py="6px"
        alignSelf="flex-start"
      >
        <Text variant="small" className="text-secondary-700 font-medium">
          Job description
        </Text>
      </Box>
      <Box>
        <Text
          variant="span"
          className="text-secondary-900 font-semibold block mb-2"
        >
          About Job
        </Text>
        <Text variant="p" className="text-secondary-700 whitespace-pre-wrap">
          {data.jdMarkdown}
        </Text>
      </Box>
    </Flex>
  );
};
